<template>
  <div>
    <!-- Question And Answer Binding Component -->
    <ResponsiveComponent>
      <!-- Mobile View Only -->
      <template #mobile>
        <LayoutOneMobile />
      </template>

      <!-- Desktop View Only -->
      <template #desktop>
        <LayoutOneDesktop />
      </template>
    </ResponsiveComponent>
  </div>
</template>

<script>
  import ResponsiveComponent from "@/components/Utilities/ResponsiveComponent/ResponsiveComponent.vue"
  import LayoutOneMobile from "./LayoutOneMobile.vue"
  import LayoutOneDesktop from "./LayoutOneDesktop.vue"

  export default {
    name: "LayoutOne",
    components: {
      ResponsiveComponent,
      LayoutOneDesktop,
      LayoutOneMobile,
    },
    props: {
      bindingType: {
        type: String,
        default: "",
      },
    },
    computed: {},
  }
</script>
